import React from 'react'
import { useTranslation } from 'lib/i18n'

import Emoji from '../../UI/Emoji/Emoji'
import BookOccasionButton from '../BookOccasionButton/BookOccasionButton'
import { RequestOccasionProps } from '../type'

import styles from './OccasionCard.module.css'

type OccasionCardProps = {
  occasion: RequestOccasionProps
  profileName: string
  profileSlug: string
}

const OccasionCard = ({
  occasion,
  profileName,
  profileSlug,
}: OccasionCardProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div
      style={{
        backgroundColor: occasion.color.replace('0.8', '0.1'),
      }}
      className={styles.card}
    >
      <div>
        <Emoji emoji={occasion.emoji} className={styles.emoji} />
        <div className={styles.title}>
          {t(occasion.title, occasion.title).toUpperCase()}
        </div>
        <div className={styles.message}>
          {t(
            'ProfilePage.OccasionCard.message',
            'Get a video message from {{profileName}}',
            { profileName },
          )}
        </div>
      </div>

      <BookOccasionButton
        profileSlug={profileSlug}
        occasionId={occasion.id}
        theme="dark"
      />
    </div>
  )
}

export default OccasionCard
